export const DATA_TABLE_LIST = [

    {
        'key': 'picksearchtd',
        'value': 'Pick Management',
    },
    {
        'key': 'pickstatusinquirytd',
        'value': 'Picking Status Inquiry',
    }
];




// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/outbound/pick-management/services/pick-management-tables.ts